import {useStores} from '../stores/use-stores';

export default function useStorePriceDisplayConditions() {
  const {userStore, rewardsStore, shopSelectionStore} = useStores();

  // Direct access to MobX observables - reactivity handled by observer components
  const isLoggedIn = userStore.isLoggedIn;
  const isRewardsMember = rewardsStore.hasRewards;
  const selectedShopLoyaltyEnabled = shopSelectionStore.loyaltyEnabled;

  const storePriceDisplayConditions = {
    showMemberPrice: {
      // DIS-1590: `publicPricing` answers "is this shopper charged the member price",
      // so it needs the same login terms the private arm already has. It previously
      // asked only whether the STORE was loyalty-enabled, which over-quoted every
      // logged-out shopper.
      //
      // Measured 2026-09-02, product 59dea8d7e1272f132a001002 at a loyalty-enabled
      // store, no session: MFL returned `sell_price_cents: 5399` (the non-member
      // figure) and charged `subtotal.cents_inc_tax` of 5399, while the app displayed
      // the 5199 `lmg_loyalty` extra. MFL advertises 5199 to a guest via the
      // `public_loyalty_member` sticker, but does not sell at it without a session.
      publicPricing: selectedShopLoyaltyEnabled && isRewardsMember && isLoggedIn,
      privatePricing: selectedShopLoyaltyEnabled && isRewardsMember && isLoggedIn,
      // Advertising, not entitlement — see UserPriceState.
      storeLoyaltyEnabled: selectedShopLoyaltyEnabled,
    },
    priceDisplayConditions: {
      isLoggedIn,
      isRewardsMember,
      selectedShopLoyaltyEnabled,
    },
  };

  return storePriceDisplayConditions;
}
